import Vue from 'vue';
import Router from 'vue-router';
import Search from '@/components/Search';
import Result from '@/components/Result';
import Checkout from '@/components/Checkout';
import Success from '@/components/Success';
import Profile from '@/components/Profile';
import Tickets from '@/components/Tickets';
import Error from '@/components/Error';
import Page from '@/Page';

import api from '@/api';
import { getLocale, isUrlLang, useDefaultPoints, getCustomRoutes, getBuyerId } from '../utils/utils';

const avalibleLang = ['ru', 'uk', 'en', 'ua', 'cz', 'pl', 'cs', 'pt'];
const routes = getCustomRoutes();

Vue.use(Router);

const opts = {
  mode: 'history',
  routes: [
    {
      path: routes.main,
      name: 'Main',
      component: useDefaultPoints ? Result : Search,
      ...isUrlLang ? { alias: '/:locale' } : {},
    },
  ],
};

const additionalRoutes = [
  {
    path: routes.search,
    name: 'Result',
    component: Result,
  },
  // only for `viabona.com.ua`
  {
    path: routes.results,
    name: 'ResultViabona',
    component: Result,
  },
  {
    path: routes.checkout,
    name: 'Checkout',
    component: Checkout,
  },
  {
    path: routes.success,
    name: 'Success',
    component: Success,
  },
  {
    path: routes.error,
    name: 'Error',
    component: Error,
  },
  {
    path: 'profile',
    name: 'Profile',
    component: Profile,
    meta: { auth: true },
  },
  {
    path: 'tickets',
    name: 'Tickets',
    component: Tickets,
    meta: { auth: true },
  },
  {
    path: '*',
    name: 'MainWithRedirect',
    component: Search,
  },
];

opts.routes.push({
  path: isUrlLang ? '/:locale' : '/',
  component: Page,
  children: additionalRoutes,
});

const router = new Router(opts);

router.beforeEach((to, from, next) => {
  if (isUrlLang) {
    if (!avalibleLang.includes(to.path.split('/')[1])) {
      const locale = getLocale();
      let path = to.path.split('/');

      if (path[0] === '') path.shift();
      if (avalibleLang.includes(path[0])) path.shift();

      path = path[0] ? `/${locale}/${path.join('/')}` : `/${locale}`;

      /* eslint no-param-reassign: 0 */
      next({ path, query: to.query });
    }
  }

  if (to.meta.auth) {
    const buyerId = getBuyerId();

    if (!buyerId) {
      next({ path: `/${to.params.locale}` });
    } else {
      api.Authentication.user(buyerId)
        .then(() => {
          next();
        })
        .catch(() => {
          if (isUrlLang) {
            next({ path: `/${to.params.locale}` });
          } else {
            next({ path: '/' });
          }
        });
    }
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js